<script setup>
/* eslint-disable @intlify/vue-i18n/no-dynamic-keys -- LumerAI resource keys share a fixed catalog. */
import { ref, computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  bulkIds: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['deleteSuccess']);

const { t } = useI18n();
const store = useStore();
const bulkDeleteDialogRef = ref(null);
const i18nKey = computed(() => {
  const i18nTypeMap = {
    AssistantResponse: 'RESPONSES',
    AssistantDocument: 'DOCUMENTS',
  };
  return i18nTypeMap[props.type];
});

const handleBulkDelete = async ids => {
  if (!ids) return;

  try {
    await store.dispatch('lumeraiBulkActions/handleBulkDelete', {
      ids: Array.from(props.bulkIds),
      type: props.type,
    });

    emit('deleteSuccess');
    useAlert(t(`LUMERAI.${i18nKey.value}.BULK_DELETE.SUCCESS_MESSAGE`));
  } catch (error) {
    useAlert(t(`LUMERAI.${i18nKey.value}.BULK_DELETE.ERROR_MESSAGE`));
  }
};

const handleDialogConfirm = async () => {
  await handleBulkDelete(Array.from(props.bulkIds));
  bulkDeleteDialogRef.value?.close();
};

defineExpose({ dialogRef: bulkDeleteDialogRef });
</script>

<template>
  <Dialog
    ref="bulkDeleteDialogRef"
    type="alert"
    :title="t(`LUMERAI.${i18nKey}.BULK_DELETE.TITLE`)"
    :description="t(`LUMERAI.${i18nKey}.BULK_DELETE.DESCRIPTION`)"
    :confirm-button-label="t(`LUMERAI.${i18nKey}.BULK_DELETE.CONFIRM`)"
    @confirm="handleDialogConfirm"
  />
</template>
